<div *ngIf="authorized">
  Authorization complete! This window should close any moment now.
</div>
<div *ngIf="!authorized">
  Authorization failed!
</div>
